export const baseDropDownContainerStyle = {
    DEFAULT: {
        backgroundColor: 'pearl',
        padding: 4,
        borderRadius: 3,
        centerVertical: true,
        border: 1,
        borderColor: 'moon-3',
    },
    SMALL: {
        centerVertical: true,
    },
}

export type TextStyle = {
    lineHeight: '20px' | '16px'
    fontSize: 11 | 14
    color: 'onyx' | 'keshi-3'
    numberOfLines: 1
    textAlign?: 'right'
    paddingRight?: '4px'
    fontFamily?: 'Sport1-Regular'
}

export const baseDropDownTextStyle: { DEFAULT: TextStyle; SMALL: TextStyle } = {
    DEFAULT: {
        lineHeight: '20px',
        fontSize: 14,
        color: 'onyx',
        numberOfLines: 1,
    },
    SMALL: {
        lineHeight: '16px',
        fontSize: 11,
        color: 'keshi-3',
        numberOfLines: 1,
        textAlign: 'right',
        paddingRight: '4px',
    },
}
